import { list } from 'src/app/common/classes/request-builder';
import { TypeAheadInterface } from 'src/app/common/components/form-builder/form-builder.component';
import { ClienteModel } from 'src/app/models/cliente.model';
import { ProductosModel } from 'src/app/models/productos/productos.model';
import { MantenimientoModel } from 'src/app/models/trabajadores/mantenimiento.model';
import { UserModel } from 'src/app/models/usuarios/user.model';

export class FertilizantesListsDefinition {
    public fincas = list();
    
    public sectores = list();
    
    public parcelas = list();
    
    public trabajadores: TypeAheadInterface<MantenimientoModel> = list();
    
    public users: TypeAheadInterface<UserModel> = list();
    
    public tipo_fertilizacion: TypeAheadInterface<string> = list(
        ['...', null],
        'Abono foliar',
        'Abono de cobertera',
        'Abono de fondo',
        'Fertirrigación'
    );
    
    public tipo_fertilizacion_covidai: TypeAheadInterface<string> = list(
        ['...', null],
        'Foliar',
        'Abono foliar',
        'Abono de cobertera',
        'Abono de fondo',
        'Fertirrigación',
        'Otros'
    );
    
    public buenasPracticasFertilizantes: TypeAheadInterface<string> = list();
          
    public metodosAplicacionFertis: TypeAheadInterface<string> = list();
    
    public tiposFertilizacionSIEX: TypeAheadInterface<string> = list();
        
    public estadoTareas: TypeAheadInterface<string> = list(
        ['...', null],
        'Orden de Trabajo',
        'Parte de Trabajo'
    );
        
    public weekDays: TypeAheadInterface<string> = list(
        'L',
        'M',
        'X',
        'J',
        'V',
        'S',
        'D'
    );
    
    public clientes: TypeAheadInterface<ClienteModel> = list();

    public productos: TypeAheadInterface<ProductosModel> = list();
        
    public prioridades: TypeAheadInterface<string> = list(
        ['...', null],
        'Alta',
        'Realizada'
    );
}